// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { createElement,forwardRef, Ref } from 'react';
import { IconBase, IconProps } from '../icon';

const element = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"defs","attrs":{},"children":[{"tag":"mask","attrs":{"id":"props.overlapMaskId_fill1","maskUnits":"userSpaceOnUse","maskContentUnits":"userSpaceOnUse","mask-type":"luminance","x":"0","y":"0","width":"24","height":"24"},"children":[{"tag":"rect","attrs":{"x":"0","y":"0","width":"24","height":"24","fill":"#fff"}},{"tag":"path","attrs":{"stroke":"#000","d":"M17 3V4M17 4V7M17 4H18M17 4H7M17 7H7M17 7L20 11M7 7V4M7 7L4 11M7 4V3M7 4H6M4 11V21M4 11H3M4 11H9M4 21H3M4 21H9M20 11V21M20 11H21M20 11H15M20 21H21M20 21H15M9 21V11M9 21H15M9 11H15M15 11V21","strokeLinecap":"square","strokeWidth":"props.strokeWidth","fill":"none"}}]}]},{"tag":"g","attrs":{"id":"teahouse"},"children":[{"tag":"path","attrs":{"id":"fill1","fill":"props.fillColor1","d":"M17 7L20 11V21H4V11L7 7V4H17V7Z","mask":"props.overlapMaskUrl_fill1"}},{"tag":"path","attrs":{"id":"stroke1","stroke":"props.strokeColor1","d":"M17 3V4M17 4V7M17 4H18M17 4H7M17 7H7M17 7L20 11M7 7V4M7 7L4 11M7 4V3M7 4H6M4 11V21M4 11H3M4 11H9M4 21H3M4 21H9M20 11V21M20 11H21M20 11H15M20 21H21M20 21H15M9 21V11M9 21H15M9 11H15M15 11V21","strokeLinecap":"square","strokeWidth":"props.strokeWidth"}}]}]};

const TeahouseIcon = forwardRef<SVGElement, IconProps>((props: IconProps, ref: Ref<SVGElement>) => createElement(
  IconBase,
  {
    ...props,
    id: 'teahouse',
    ref,
    icon: element,
  },
));

TeahouseIcon.displayName = 'TeahouseIcon';

export default TeahouseIcon;
